import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA,MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-test-datasource",
  templateUrl: "./test-datasource.component.html",
  styleUrls: ["./test-datasource.component.css"],
})
export class TestDatasourceComponent implements OnInit {
  bodyParams = [];
  queryParams = [];
  headerParams = [];
  arrayBodyParams=[];
  bodyType;
  unAssigendOutParams: any[] = [];
  assigendOutParams: any[] = [];
  path: string;
  testData;
  headers: HttpHeaders;
  dataSourceHeader: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TestDatasourceComponent>,
    private httpClient: HttpClient
  ) { }

  ngOnInit() {
       for (let i = 0; i < this.data.bodyParams.length; i++) {
      this.bodyParams.push({ name: this.data.bodyParams[i].paramName,value:this.data.bodyParams[i].defaultValue });
    }
    for (let i = 0; i < this.data.queryParams.length; i++) {
      this.queryParams.push({ name: this.data.queryParams[i].paramName ,value:this.data.queryParams[i].defaultValue});
    }
    for (let i = 0; i < this.data.headerParams.length; i++) {
      this.headerParams.push({ name: this.data.headerParams[i].paramName ,value:this.data.headerParams[i].defaultValue});
    }
    for (let i = 0; i < this.data.arrayBodyParams.length; i++) {
      this.arrayBodyParams.push({ name: this.data.arrayBodyParams[i].paramName ,value:this.data.arrayBodyParams[i].defaultValue});
    }
    this.unAssigendOutParams = this.data.unAssigendOutParams;
    this.assigendOutParams = this.data.assigendOutParams;

    this.testData = this.data.firstStepData;
    this.path = this.data.path;
    this.bodyType=this.data.bodyType
    this.dataSourceHeader = this.data.dataSourceHeader;

  }

  testApi() {
    var temp = {};
    
    let inputTypeNames = [];
    for (let i = 0; i < this.bodyParams.length; i++) {
      temp[this.bodyParams[i].name] = this.bodyParams[i].value;
      inputTypeNames.push(this.bodyParams[i].name);
    }
    for (let i = 0; i < this.arrayBodyParams.length; i++) {
      temp[this.arrayBodyParams[i].name] = this.arrayBodyParams[i].value;
      inputTypeNames.push(this.arrayBodyParams[i].name);
    }
    for (let i = 0; i < this.queryParams.length; i++) {
      temp[this.queryParams[i].name] = this.queryParams[i].value;
      inputTypeNames.push(this.queryParams[i].name);
    }
    for (let i = 0; i < this.headerParams.length; i++) {
      temp[this.headerParams[i].name] = this.headerParams[i].value;
      inputTypeNames.push(this.headerParams[i].name);
    }
    this.testData.obj = temp;
    this.testData.obj.inputType = inputTypeNames;

    this.headers = new HttpHeaders({ 'token': this.dataSourceHeader ? this.dataSourceHeader : '' });
    this.httpClient
      .post(`/ApiInvoker/TestInvokerAPI`, this.testData, {
        headers: this.headers,
      })
      .subscribe((res: any) => {
               this.unAssigendOutParams = res;
        this.getOutParamKeys(this.path);
        this.dialogRef.close({ unAssigendOutParams: this.unAssigendOutParams, fullResponse: res });
      }, (err: HttpErrorResponse) => {
        this.dialogRef.close(err);
      });
  }

  cancelHandler() {
    this.dialogRef.close([]);
  }

  getOutParamKeys(path) {
       var pathResult;
    if (path) {
      pathResult = path.split("=>");
    }
    if (pathResult && pathResult.length > 0) {
      for (let index = 0; index < pathResult.length; index++) {
        if(Array.isArray(this.unAssigendOutParams) && this.unAssigendOutParams.length > 0)
        this.unAssigendOutParams = this.unAssigendOutParams[0]
        const item = this.unAssigendOutParams[pathResult[index]];
        if (
          item
        ) {
          if (Array.isArray(item) && item.length > 0) {
            this.unAssigendOutParams = item;
          }else if (typeof item == 'object' && Object.keys(item).length> 0){
            this.unAssigendOutParams = [item];
          } else {
            this.unAssigendOutParams = [];
          }
        }else {
          this.unAssigendOutParams = [];
        }
      }
    }
    this.checkResType(this.unAssigendOutParams);
  }

  checkResType(instance) {
       if (Array.isArray(instance)) {
      this.unAssigendOutParams = [];
      this.checkResType(instance[0]);
    } else if (typeof instance === "object") {
      this.unAssigendOutParams = [];
      var keys = Object.keys(instance);

      keys.forEach((item, index) => {
        this.unAssigendOutParams.push(item);
      });
    }
    this.unAssigendOutParams = this.excludeSelected(
      this.unAssigendOutParams,
      this.assigendOutParams
    );
  }

  excludeSelected(unAssignedarray, assignedArray) {
    if (Array.isArray(unAssignedarray)) {
      if (assignedArray)
        assignedArray.forEach((element) => {
          let index = unAssignedarray.findIndex(
            (arrayItem) => arrayItem == element
          );
          if (index != -1) {
            unAssignedarray.splice(index, 1);
          }
        });
    } else {
      unAssignedarray = [];
    }
    return unAssignedarray;
  }
}
